export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/video_editing.79e944d.svg";